export enum QuestionTypesEnum {
    RADIO = 1,
    INPUT = 2,
    CHECKBOX = 3
}

export enum VerificationCodeSourceEnum {
   EMAIL = 1,
   SMS = 2
}

export enum SurveyTypesEnum {
    GENERAL = 0,
    ORG_ENVIRONMENT = 1,
    IMPROVEMENTS_PROPOSALS = 2,
    FIELD_WORK = 3
}

export enum LibraryTypesEnum {
    LIBRARY = 'library',
    LINKS = 'links'
}
